module.exports = __webpack_public_path__ + "img/111.a5fb2edc.png";